import { useCallback, useMemo } from 'react';
import { pick, prop } from 'ramda';

import { IMenuItemConfig } from '@core/js/components/system/App/store/types';
import { useAppSelector, usePageSelector } from '@core/js/store/hooks';
import { getCleanUrl } from '@core/js/utils/url.util';

import { deepFind } from '@interlayer/js/custom/utils/methods.util';

const find = (items: IMenuItemConfig[], path: string) => {
    return deepFind({ items, childrenKey: 'children', sourceKey: 'friendlyURL', source: path });
};

export const useGetFindItemMenu = () => {
    const menuItems = useAppSelector(prop('menuItems'));

    return useCallback((friendlyURL: string) => {
        return find(menuItems, friendlyURL);
    }, [menuItems]);
};

export const useCurrentItemMenu = (path: string) => {
    const getFindItemMenu = useGetFindItemMenu();
    return useMemo(() => getFindItemMenu(path), [getFindItemMenu, path]);
};

export const useCheckIsActiveLink = (currentPageURL?: string) => {
    const rootPage = useAppSelector(prop('rootPage'));
    const { friendlyURL, path } = usePageSelector(pick(['friendlyURL', 'path']));

    const cleanUrl = friendlyURL || path && getCleanUrl(path);
    const pageURL = currentPageURL || cleanUrl;

    return useCallback((url: string) =>
        url === pageURL || pageURL === '/' && url === rootPage,
    [pageURL, rootPage]);
};
